const placeholder = (tempClass, inputId = 'email', placeholderId = 'email-placeholder') => {
    const input = document.getElementById(inputId);
    if (!input) {
        return;
    }

    const emptyInput = 'full-input';
    const placeholderEl = document.getElementById(placeholderId);
    let inputWidth = input.getBoundingClientRect().width;

    const preparePlaceholderWidth = (text) => {
        const element = document.createElement('span');
        element.className = tempClass;
        document.body.appendChild(element);

        element.textContent = text;
        let elemText = element.innerHTML;
        elemText = elemText.replace(/\s/g, '&nbsp;');
        element.innerHTML = elemText;

        const width = Math.ceil(element.getBoundingClientRect().width);
        element.remove();

        return width;
    };

    const formatInputField = (inputText) => {
        const textWidth = preparePlaceholderWidth(inputText);
        let placeholderWidth = textWidth + 1;
        if (textWidth >= inputWidth) {
            placeholderWidth = inputWidth;
        }

        if (placeholderWidth > 1) {
            placeholderEl.style.marginLeft = `${placeholderWidth}px`;
            placeholderEl.style.display = 'block';
            placeholderEl.style.maxWidth = `calc(83% - ${placeholderWidth}px)`;
        } else {
            placeholderEl.removeAttribute('style');
        }
    };

    if (input.value.length) {
        input.classList.remove(emptyInput);
        inputWidth = input.getBoundingClientRect().width;
        formatInputField(input.value);
    }

    window.addEventListener('resize', () => {
        inputWidth = input.getBoundingClientRect().width;
        formatInputField(input.value);
    });

    input.addEventListener('input', () => {
        if (input.value.length) {
            if (input.classList.contains(emptyInput)) {
                input.classList.remove(emptyInput);
                inputWidth = input.getBoundingClientRect().width;
            }
        } else {
            input.classList.add(emptyInput);
        }
        formatInputField(input.value);
    });
};

export default placeholder;
